import useMembership from '@space-shell/common/hooks/useMembership'
import useMutation from '@space-shell/common/hooks/useMutation'
import { CommunitiesEndpoints, CommunitiesService } from '@space-shell/common/services/communities'
import { queryClient } from '@space-shell/config/request'

export const useDeleteCommunity = () => {
  const { membershipSlug } = useMembership()

  return {
    deleteCommunityQuery: useMutation((id: number) => CommunitiesService.deleteCommunity(id)),
    invalidateQueries: () =>
      Promise.all([
        queryClient.invalidateQueries([CommunitiesEndpoints.getGroupCommunities(membershipSlug)]),
        queryClient.invalidateQueries([
          CommunitiesEndpoints.getGroupCommunitiesPublic(membershipSlug)
        ])
      ])
  }
}
